const items = [
  "IN-STORE MANPOWER",
  "VAN DELIVERY ASSOCIATES",
  "BIG BILLION DAYS READY",
  "ROUTE EXPERTISE",
  "4-HOUR BACKUP GUARANTEE",
  "SALARY-BASED STAFFING",
  "WAREHOUSE & LOGISTICS",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#111827] py-5 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-xl sm:text-2xl font-semibold uppercase tracking-wide text-slate-400 px-6">
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[#d4af37] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
